export default __webpack_public_path__ + "static/PLM CSS-e123ded0dc84fd720abbcaa2d8c94956.png";